import { Dispatch, SetStateAction } from "react";

export default function Tabs({
  tabs,
  activeTab,
  setActiveTab,
  resetSearch = "",
}: {
  tabs: string[];
  activeTab: string;
  setActiveTab: Dispatch<SetStateAction<string>>;
  resetSearch?: any;
}) {
  const handleTabClick = (tabName: string) => {
    setActiveTab(tabName);
    resetSearch()
  };

  return (
    <div className="w-100">
      <div className="d-flex justify-content-sm-end justify-content-start overflow-auto text-nowrap">
        {tabs.map((tab, index) => (
          <button
            key={index}
            id={
              activeTab === tab
                ? ""
                : "outlined_button_primary"
            }
            className={`rounded-pill fs btn btn-sm btn-primary  ${activeTab === tab ? "" : "border"
              }`}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </button>
          //   <button
          //     id={
          //       activeTab === tab
          //         ? ""
          //         : "outlined_button_primary"
          //     }
          //     key={index}
          //     className={`
          //   btn mx-1 px-3 py-2 flex-shrink-0
          //   ${activeTab === tab
          //         ? "btn-primary shadow-sm"
          //         : "border"
          //       }
          // `}
          //     onClick={() => handleTabClick(tab)}
          //   >
          //     {tab}
          //   </button>
        ))}
      </div>
    </div>
  );
}
